import $ from 'jquery'
import {Offcanvas} from 'bootstrap';

const {__} = wp.i18n
import {Modal} from 'bootstrap'

const object = vnObject

const body = document.body

const setThemeVars = () => {
    const documentWidth = document.documentElement.clientWidth
    const width = Math.abs(window.innerWidth - documentWidth)
    body.style.setProperty('--scrollbar-width', `${width}px`)

    const mainContainer = document.querySelector('#colophon > .container')
    const mainContainerWidth = mainContainer.clientWidth

    const col = document.querySelector('.vn-col-sizer')
    const colWidth = col.clientWidth

    const headerContainer = document.querySelector('.site-header')
    const headerContainerHeight = headerContainer.clientHeight

    body.style.setProperty(
        '--space-width',
        `${(documentWidth - mainContainerWidth) / 2}px`
    )

    body.style.setProperty('--container-width', `${mainContainerWidth}px`)
    body.style.setProperty('--main-width', `${documentWidth}px`)
    body.style.setProperty('--col-width', `${colWidth}px`)
    body.style.setProperty('--header-height', `${headerContainerHeight}px`)
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)

$('.vn-btn-terms button').on('click', function (e) {
    e.preventDefault()
    window.location.href = $(this).attr('data-url')
})

const allModals = document.querySelectorAll('[data-bs-toggle="modal"]')
if (allModals.length) {
    ;[...allModals].map((modal) => {
        new Modal(modal)
    })
}


const toc = $('.vn-toc')
if (toc.length) {
    const headings = $('.entry-content h2')
    if (headings.length) {
        const list = toc.find('ul')
        headings.map((index, heading) => {
            if (heading) {
                heading.id = `toc-${index}`
                list.append(`<li><a class="vn-toc-link" href="#toc-${index}">${heading.innerText}</a></li>`)
            }
        })
    }
}

$('.js-read-more').on('click', function () {
    const button = $(this)
    const button_parent = $(this).closest('.js-more')

    if (button_parent.hasClass('active')) {
        button.html(object.readMore)
    } else {
        button.html(object.readLess)
    }

    button_parent.toggleClass('active')
})

function refreshCartCount() {
    // Récupère le nombre actuel depuis le fragment WooCommerce (si présent)
    var count = $('.woocommerce-cart-form .cart_item input.qty').length ? 0 : $('.cart-count').text();
    // Si tu es sur une page hors panier, WooCommerce mettra à jour via added_to_cart
    if (typeof wc_cart_fragments_params !== 'undefined') {
        // Récupère le nombre de produits dans le panier via le fragment
        // Mais si tu ne veux pas de fragments, on peut juste écouter l’événement et incrémenter/decrémenter
    }
}

// Quand un produit est ajouté au panier via AJAX
$(document.body).on('added_to_cart', function (event, fragments, cart_hash, $button) {
    var newCount = parseInt($('.cart-count').text()) + 1; // incrémente de 1
    $('.cart-count').text(newCount);
});

// Quand un produit est retiré du panier via AJAX
$(document.body).on('removed_from_cart', function () {
    var newCount = parseInt($('.cart-count').text()) - 1; // décrémente de 1
    if (newCount < 0) newCount = 0;
    $('.cart-count').text(newCount);
});

// Quand le panier est mis à jour (quantités modifiées sur la page panier)
$(document.body).on('updated_cart_totals', function () {
    var total = 0;
    $('.woocommerce-cart-form .cart_item input.qty').each(function () {
        total += parseInt($(this).val());
    });
    $('.cart-count').text(total);
});

document.addEventListener('DOMContentLoaded', function (dom) {
    setTimeout(() => {
        const dataHrefs = dom.target.querySelectorAll('[data-href]')
        if (dataHrefs.length) {
            dataHrefs.forEach((el) => {
                el.addEventListener('click', (e) => {
                    e.preventDefault()
                    window.location.href = el.dataset.href
                })
            })
        }

        // Après reload
        let lastProduct = document.body.className.split(' ').includes('last_product');
        if (lastProduct) {
            let offcanvasEl = document.getElementById("offcanvasTabAddedToCart");
            let bsOffcanvas = new Offcanvas(offcanvasEl);
            bsOffcanvas.show();
        }
    }, 200)
})
